import { RequestService } from 'services/request.service'

import { DeckHelp } from 'services/apiTypes/deckHelp.types'

export class DeckHelpService extends RequestService {
  create = async (deckId: string | number, body: DeckHelp): Promise<DeckHelp> => {
    return super.post(`/api/decks/${deckId}/help/`, body)
  }

  update = async (deckHelpId: string | number, body: DeckHelp): Promise<DeckHelp> => {
    return super.patch(`/api/decks/help/${deckHelpId}/`, body)
  }

  remove = async (id: string | number): Promise<void> => {
    return super.delete(`/api/decks/help/${id}/`, undefined, true)
  }
}

const deckHelpService = new DeckHelpService()

export default deckHelpService
